module.exports = __webpack_public_path__ + "static/media/c5bannerModul2_small.3d8a3a9b.jpg";